import React from "react";

import styles from "./Lozenge.module.scss";

export default function Lozenge({
  appearance,
  onClick,
  isBold,
  isUpper,
  children,
  style,
}) {
  return (
    <div
      onClick={onClick}
      className={`${styles["lozenge-container"]} ${
        styles[`lozenge-container--${appearance || "default"}`]
      } ${isBold && styles["lozenge-container--bold"]} ${
        isUpper && styles["lozenge-container--upper"]
      }`}
      style={style}
    >
      {children}
    </div>
  );
}
